export default "__VITE_ASSET__QNl16A_0__"